import { JurisdictionsBrokerageOfferingsItem } from '@models/productOffering';

export const getEarliestEffectiveOn = (jurisdictions: JurisdictionsBrokerageOfferingsItem[]): Date => {
  return jurisdictions.sort(
    (a, b) => (a.effectiveOn ? a.effectiveOn.getTime() : 0) - (b.effectiveOn ? b.effectiveOn.getTime() : 0),
  )[0].effectiveOn;
};

export const getLatestEffectiveThrough = (jurisdictions: JurisdictionsBrokerageOfferingsItem[]): Date | null => {
  if (jurisdictions.length) {
    return jurisdictions.sort(
      (a, b) =>
        (b.effectiveThrough ? b.effectiveThrough.getTime() : 0) -
        (a.effectiveThrough ? a.effectiveThrough.getTime() : 0),
    )[0].effectiveThrough;
  }
  return null;
};
